/** Same-origin endpoints: the HTTPS gateway owns cookies and injects kernel tokens. */
export const COREBOS_API_URL = import.meta.env.VITE_COREBOS_API_URL || "/api";
export const KERNEL_API_URL = import.meta.env.VITE_KERNEL_API_URL || "/kernel/api/v1";
